import { login, logout } from "./actions";
import { RootState } from "@/app/appStore";
import { isAnyOf } from "@reduxjs/toolkit";
import { AppStartListening } from "@/app/appMiddleware";
import { appSession } from "@/shared/lib/storage";

export function addAuthListener(startListening: AppStartListening) {
  startListening({
    matcher: isAnyOf(login.fulfilled, logout.fulfilled),
    effect: (_, listenerApi) => {
      const state = listenerApi.getState() as RootState;

      if (state.auth.user) {
        appSession.setItem(state.auth.user);
      }
    },
  });
}
